import React from 'react';
// components
import Icon from '../../Icon/Icon';
// hoc
import { withRouter } from 'react-router-dom';
// styles
import styles from './HeaderIcon.mod.css';
import classnames from 'classnames/bind';

import T from 'prop-types';

let cx = classnames.bind(styles);

const HeaderIcon = ({
  backLink,
  isToggled,
  toggleSidebar,
  history,
  location: { pathname },
}) => {
  if (!isToggled && (pathname === '/' || pathname === '/login')) return null;
  if (!isToggled) {
    // return (
    //   <Icon
    //     type="close"
    //     onClick={() => history.push('/')}
    //     className={cx('header-icon')}
    //   />
    // );
    return null;
  }
  if (backLink) {
    return (
      <Icon
        type="back"
        onClick={() => history.push(backLink)}
        className={cx('header-icon')}
      />
    );
  }
  return (
    <button
      onClick={toggleSidebar}
      className={cx('header-icon', 'sidebar-toggler')}
    >
      <Icon type="sidebar" />
      <span>Panel</span>
    </button>
  );
};

HeaderIcon.propTypes = {
  backLink: T.string,
  toggleSidebar: T.func,
  isToggled: T.bool,
};

export default withRouter(HeaderIcon);



// WEBPACK FOOTER //
// ./src/components/MainHeader/components/HeaderIcon.jsx